import { buildQueryParams } from 'utils/helper';

const addQueryParams = (url: string, params: Record<string, any>) => {
  const queryParams = buildQueryParams(params);
  return `${url}${queryParams ? `?${queryParams}` : ''}`;
};

export const reportsHubTabs = {
  boardDecks: 'board-decks',
  financialAnalysis: 'financial-analysis',
  financialStatements: 'financial-statements',
  closeDeliverables: 'close-deliverables',
  kpiMetrics: 'kpi-metrics',
} as const;
export type ReportsHubTab =
  (typeof reportsHubTabs)[keyof typeof reportsHubTabs];

export const reportsHubURLs = {
  base: '/reporting/reports-hub',
  _base_relative_path: 'reports-hub',

  financialAnalysis: {
    base: '/reporting/reports-hub/financial-analysis',
    new: '/reporting/reports-hub/financial-analysis/new',
    edit({ id }: { id: string }) {
      return `/reporting/reports-hub/financial-analysis/edit/${id}`;
    },
    view({ id }: { id: string }) {
      return `/reporting/reports-hub/financial-analysis/view/${id}`;
    },
    preview(params: {
      analysisId?: string;
      createType?: string;
      prompt?: string;
    }) {
      return addQueryParams(
        '/reporting/reports-hub/financial-analysis/new/preview',
        params
      );
    },
  },

  financialStatements: {
    base: '/reporting/reports-hub/financial-statements',
    create: '/reporting/reports-hub/financial-statements/create',
    view({ report_type, id }: { report_type: string; id: string }) {
      return `/reporting/reports-hub/financial-statements/${report_type}/${id}`;
    },
    editDraft({ id }: { id: string }) {
      return `/reporting/reports-hub/financial-statements/drafts/${id}/edit`;
    },
    demo: '/reporting/reports-hub/financial-statements/demo/cash-flow-direct',
    budgetsVsActuals({ id }: { id: string }) {
      return `/reporting/reports-hub/financial-statements/BvA/${id}`;
    },
  },

  closeDeliverables: {
    base: '/reporting/reports-hub/close-deliverables',
  },

  boardDecks: {
    base: '/reporting/reports-hub/board-decks',
  },

  cashFlowForecast: {
    base: '/reporting/reports-hub/financial-statements/demo/cash-flow-forecast',
    intakeForm:
      '/reporting/reports-hub/financial-statements/demo/cash-flow-forecast/intake-form',
    view({ id }: { id: string }) {
      return `/reporting/reports-hub/financial-statements/demo/cash-flow-forecast/${id}`;
    },
    edit({ id }: { id: string }) {
      return `/reporting/reports-hub/financial-statements/demo/cash-flow-forecast/${id}/edit`;
    },
    preview(params: {
      analysisId?: string;
      createType?: string;
      prompt?: string;
    }) {
      return addQueryParams(
        '/reporting/reports-hub/financial-statements/demo/cash-flow-forecast/preview',
        params
      );
    },
  },

  kpiMetrics: {
    base: '/reporting/reports-hub/kpi-metrics',
    saasMetrics: '/reporting/reports-hub/kpi-metrics/saas-metrics',
    revenueEfficiencyMetrics:
      '/reporting/reports-hub/kpi-metrics/revenue-efficiency-metrics',
    executiveReportDemo:
      '/reporting/reports-hub/kpi-metrics/demo/executive-report',
    weeklyCovers: '/reporting/reports-hub/kpi-metrics/weekly-covers',
    dailyNetSales: '/reporting/reports-hub/kpi-metrics/daily-net-sales',
    weeklyOperationalAnalytics:
      '/reporting/reports-hub/kpi-metrics/weekly-operational-analytics',
    laborDistributionAnalysis:
      '/reporting/reports-hub/kpi-metrics/labor-distribution-analysis',
    sigmaReport: '/reporting/reports-hub/kpi-metrics/sigma-report',
  },
} as const;
